module.exports = "/_next/static/images/074d0567254c3c055a38c34f7509074b-man-looking-up-smiling-xs@2x.jpg.webp";